import { colors } from 'app-v2/design-systems/theme/colors'
import { fonts } from 'app-v2/design-systems/typography/fonts'
import { COLOR } from 'app-v2/design-tokens'

const backgroundColor = {
    dashboardBackgroundColor: colors.lightMayo,
    tabHeaderActiveBackgroundColor: colors.white,
    tabHeaderInactiveBackgroundColor: COLOR.SECONDARY
}

const border = {
    borderRadius: 10,
    largeBorderRadius: 18,
    mediumBorderRadius: 12,
    shadowBox: `box-shadow: 0 1px 4px ${colors.darkGrey};`
}

const fontColor = {
    bodyFontColor: COLOR.PRIMARY,
    captionFontColor: COLOR.PRIMARY,
    errorFontColor: colors.fieryRed,
    formPlaceholderFontColor: colors.greyBbqBrown,
    h5FontColor: COLOR.PRIMARY,
    h6FontColor: COLOR.PRIMARY,
    h7FontColor: COLOR.PRIMARY,
    h8FontColor: COLOR.PRIMARY,
    h9FontColor: COLOR.PRIMARY,
    smallCaptionFontColor: colors.lightBrown,
    stepLabelFontColor: colors.meltyYellow,
    offerPointsFontColor: COLOR.PRIMARY,
    tabHeaderActiveFontColor: COLOR.PRIMARY,
    tabHeaderInactiveFontColor: colors.lightBrown
}

const fontFamily = {
    bodyFontFamily: fonts.flameSansRegular,
    captionFontFamily: fonts.flameSansRegular,
    extraSmallButtonFontFamily: fonts.flameRegular,
    h5FontFamily: fonts.flameRegular,
    h6FontFamily: fonts.flameRegular,
    h7FontFamily: fonts.flameRegular,
    h8FontFamily: fonts.flameRegular,
    h9FontFamily: fonts.flameRegular,
    stepLabelFontFamily: fonts.flameRegular,
    smallCaptionFontFamily: fonts.flameSansRegular,
    smallButtonFontFamily: fonts.flameRegular,
    offerPointsFontFamily: fonts.flameRegular,
    tabHeaderFontFamily: fonts.flameSansRegular
}

const fontSize = {
    bodyFontSize: 16,
    captionFontSize: 14,
    extraSmallButtonFontSize: 13,
    h5FontSize: 28,
    h6FontSize: 16,
    h7FontSize: 20,
    h8FontSize: 18,
    h9FontSize: 15,
    mediumH5FontSize: 36,
    mediumH6FontSize: 24,
    smallButtonFontSize: 16,
    smallCaptionFontSize: 11,
    stepLabelFontSize: 14,
    offerPointsFontSize: 14,
    tabHeaderFontSize: 16
}

const lineHeight = {
    bodyLineHeight: 22,
    captionLineHeight: 20,
    extraSmallButtonLineHeight: 18,
    h5LineHeight: 28,
    h6LineHeight: 16,
    h7LineHeight: 20,
    h8LineHeight: 18,
    h9LineHeight: 22,
    mediumH5LineHeight: 36,
    mediumH6LineHeight: 24,
    smallButtonLineHeight: 16,
    smallCaptionLineHeight: 15,
    stepLabelLineHeight: 16,
    offerPointsLineHeight: 14,
    tabHeaderLineHeight: 16
}

const padding = {
    defaultPadding: 20,
    extraSmallButtonHorizontalPadding: 16,
    extraSmallButtonVerticalPadding: 7,
    smallButtonHorizontalPadding: 12,
    smallButtonVerticalPadding: 24,
    smallCaptionHorizontalPadding: 12,
    tabHeaderVerticalPadding: 16
}

const myCrowns = {
    myCrownsTitleIconColor: colors.meltyYellow,
    myCrownsTitleIconSize: 28,
    myCrownsTitleStyle: 'H6',
    myCrownCompleteStepContentColor: COLOR.PRIMARY,
    myCrownIncompleteStepContentColor: colors.greyDisable,
    myCrownsStepContentSize: 15
}

const stepBar = {
    stepBarLineHeight: 8,
    stepBarPreLineWidth: 15,
    stepBarPostLineWidth: 15,
    stepBarShouldDisplayPreLine: true,
    stepBarShouldDisplayPostLine: true,
    stepBarCompleteFillColor: colors.meltyYellow,
    stepBarIncompleteFillColor: colors.disable,
    stepBarCompleteLabelFillColor: colors.meltyYellow,
    stepBarIncompleteLabelFillColor: colors.greyDisable,
    stepContentContainerSize: 32
}

export const tokens = {
    ...backgroundColor,
    ...border,
    ...fontColor,
    ...fontFamily,
    ...fontSize,
    ...lineHeight,
    ...padding,
    ...myCrowns,
    ...stepBar
}
